<template>
  <div>
    <el-row :gutter="7">
      <el-col :md="6" :lg="4">
        <el-input placeholder="员工工号" v-model="params.employee_id" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :md="6" :lg="4">
        <el-input placeholder="会员卡号" v-model="params.card" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :md="6" :lg="4">
        <el-input placeholder="会员电话" v-model="params.phone" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :md="6" :lg="4">
        <el-input placeholder="员工电话" v-model="params.pharmacistTel" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <!-- <el-col :span="3">
        <el-input placeholder="门店号" v-model="params.store_inkid" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col> -->
      <el-col :md="6" :lg="5">
        <el-select v-model="params.res" placeholder="结果状态" clearable @change="searchData" style="width: 100%">
          <el-option
            v-for="item in resList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>     
    </el-row>
    <el-row :gutter="7">
      <el-col :md="6" :lg="5">
        <el-date-picker v-model="createdate" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width:100%;" @change="dateChange" size=""></el-date-picker>
      </el-col>
      <el-col :md="6" :lg="5">
        <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
      </el-col>
    </el-row>

    <el-table :data="kaikaList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="card_id" label="会员卡号卡号" width="">
        <template slot-scope="scope">
          <!--        <el-tag :color="scope.row.tag_color" size="mini" :style="'color:'+scope.row.font_color"></el-tag>-->
          {{scope.row.card}}
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" width="">
        <template slot-scope="scope">
          {{scope.row.phone}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="">
        <template slot-scope="scope">
          {{scope.row.name}}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="card_type" label="卡类型" width="250">
        <template slot-scope="scope">
          {{scope.row.card_type}}
        </template>
      </el-table-column> -->
      <el-table-column prop="store_inkid" label="所属门店" width="">
        <template slot-scope="scope">
          {{scope.row.store_inkid}}
        </template>
      </el-table-column>

      <!--      <el-table-column label="操作">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div class="operating-icons">-->
      <!--            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>-->
      <!--            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!-- <el-table-column prop="birthday" label="生日" width="250">
        <template slot-scope="scope">
          {{scope.row.birthday}}
        </template>
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="250">
        <template slot-scope="scope">
          {{scope.row.sex}}
        </template>
      </el-table-column> -->
      <el-table-column prop="employee_id" label="员工工号" width="">
        <template slot-scope="scope">
          {{scope.row.employee_id}}
        </template>
      </el-table-column>
      <el-table-column prop="pharmacistTel" label="员工电话" width="">
        <template slot-scope="scope">
          {{scope.row.pharmacistTel}}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="openId" label="openId" width="250">
        <template slot-scope="scope">
          {{scope.row.openId}}
        </template>
      </el-table-column>
      <el-table-column prop="unionid" label="unionid" width="250">
        <template slot-scope="scope">
          {{scope.row.unionid}}
        </template>
      </el-table-column> -->
      <el-table-column prop="res" label="结果" width="">
        <template slot-scope="scope">
          {{scope.row.res}}
        </template>
      </el-table-column>
      <el-table-column prop="msg" label="提示" width="">
        <template slot-scope="scope">
          {{scope.row.msg}}
        </template>
      </el-table-column>

      <el-table-column prop="createdate" label="创建时间" width="">
        <template slot-scope="scope">
          {{scope.row.createdate}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.res=='false'">
            <div class="operating-icons">
              <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
              <!--            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>-->
            </div>
          </div>
        </template>

      </el-table-column>


    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>
    </div>
    <el-dialog title="添加、编辑标签" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">


          <el-form-item class="content-left" label="会员卡号Id" prop="card_id"
                        :rules="[{ required: true, message: '请输入会员卡号Id', trigger: 'blur' }]">
            <el-input placeholder="请输入会员卡号Id" v-model="form.card_id"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="会员卡号" prop="card"
                        :rules="[{ required: true, message: 'card', trigger: 'blur' }]">
            <el-input placeholder="请输入会员卡号" v-model="form.card"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="姓名" prop="name"
                        :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
            <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="电话" prop="phone"
                        :rules="[{ required: true, message: '请输入电话', trigger: 'blur' }]">
            <el-input placeholder="请输入电话" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="saveTagData">确定保存</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  // eslint-disable-next-line no-unused-vars
  import {Message} from 'element-ui'
  // eslint-disable-next-line no-unused-vars
  import {saveKaika, getKaikaList, updateKaika, delKaika,kaikaExport} from '../../../api/member'


  export default {
    data() {
      return {
        createdate:'',
        isEdit: false,
        kaikaList: [],
        loading: false,
        exportloading:false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          card: '',
          employee_id: '',
          pharmacistTel: '',
          phone: '',
          store_inkid: ''

        },
        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',

          description: ''
        },
        memberTagDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {

      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.memberTagDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.memberTagDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {
        if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.phone)) && this.params.phone != '') {
          this.$message.error('请输入正确手机号')
        } else if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.pharmacistTel)) && this.params.pharmacistTel != '') {
          this.$message.error('请输入正确手机号')
        } else {
          this.params.page = 1
          this.getDataList()
        }
      },
      getDataList() {
        this.loading = true
        getKaikaList(this.params).then(response => {
          this.kaikaList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      deleteAction(index, row) {
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          delKaika(row.kaikaId).then(response => {
            this.kaikaList.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.memberTagDialog = false
      },
      saveTagData() {
        this.memberTagDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          updateKaika(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })

        } else {
          this.$message.error('缺少Id')
          //新增方法
          // eslint-disable-next-line no-undef
          // saveKaika(this.form).then(res => {
          //   if (res.data.data) {
          //     this.$message({
          //       type: 'success',
          //       message: '新增成功'
          //     })
          //     this.getDataList()
          //   }
          // })
        }
      },
      dateChange (val) {
        console.log(val)
    if(val){
      if (val.length > 0) {
        this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        this.params.time_start_begin = this.time_start_begin
        this.params.time_start_end = this.time_start_end
      } else {
        this.time_start_begin = ''
        this.time_start_end = ''
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
    }else {
      this.time_start_begin = ''
      this.time_start_end = ''
      this.params.time_start_begin = ''
      this.params.time_start_end = ''
    }

        this.params.page = 1

        this.getDataList()
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
      exportData() {
        this.exportloading = true
        this.params.export = 1
        kaikaExport(this.params).then(res => {
          this.exportloading = false
          console.log(res.data)
          if (res.status) {
            this.$message({
              type: 'success',
              message: '已加入执行队列，请在设置-导出列表中下载'
            })
            return
          } else if (res.data.data.url) {
            this.downloadUrl = res.data.url
            this.downloadName = res.data.filename
            this.downloadView = true
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        }).catch(error => {
          this.exportloading = false
        })
      }
    },
    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// kaika.vue?3f2ddaf9